import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import ProfilePage from "./pages/ProfilePage";
import NotFound from "./pages/NotFound";
import AuthHashHandler from "./components/auth/AuthHashHandler";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ResendActivationPage from "./pages/ResendActivationPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import PricingPage from "./pages/PricingPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import DataFormatDocs from "./pages/DataFormatDocs";
import ScrollToTop from "./components/ScrollToTop";
import PomodoroPage from "./pages/PomodoroPage";
import WidgetSetupPage from "./pages/WidgetSetupPage";
import { PostHogProvider } from "./components/PostHogProvider";
import NotificationScheduler from "./components/NotificationScheduler";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <PostHogProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <AuthProvider>
            <ScrollToTop />
            <AuthHashHandler />
            <NotificationScheduler />
            <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/resend-activation" element={<ResendActivationPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/docs/data-format" element={<DataFormatDocs />} />
            <Route path="/pomodoro" element={<PomodoroPage />} />
            <Route path="/widget-setup" element={<WidgetSetupPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </TooltipProvider>
      </PostHogProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
